export const formatIDR = (n) =>
  "IDR " + Number(n || 0).toLocaleString("id-ID");

export const formatNumber = (n) => Number(n || 0).toLocaleString("id-ID");
